// extracted by mini-css-extract-plugin
module.exports = {"footer":"_2td57","moreItemsText":"_33fQS","mobileFooter":"_3p0IB"};